import React from 'react';

import { ReactTableBodyRow, MemoizedReactTableBodyRow } from './react-table-body-row';

/**
 * @param {object} props
 * @param {import('../../../prop-types/react-table').ReactTableRowPropType[]} props.rows
 * @param {(row: import('../../../prop-types/react-table').ReactTableRowPropType) => void} props.prepareRow
 * @param {(row: import('../../../prop-types/react-table').ReactTableRowPropType) => string} [props.getBodyRowClassName]
 * @param {(row: import('../../../prop-types/react-table').ReactTableRowPropType) => React.ReactNode} [props.renderSubRow]
 * @param {boolean} [props.memoizeRows]
 * @param {string} [props.cellClassName]
 * @param {(row: import('../../../prop-types/react-table').ReactTableRowPropType) => void} [props.onRowClick]
 */
export const ReactTableBodyRows = ({
  rows,
  prepareRow,
  getBodyRowClassName,
  renderSubRow,
  memoizeRows = false,
  cellClassName,
  onRowClick,
}) => {
  const RowComponent = memoizeRows ? MemoizedReactTableBodyRow : ReactTableBodyRow;

  return rows.map((row) => {
    prepareRow(row);

    const { key: rowKey, ...rowProps } = row.getRowProps() || {};
    const bodyRowClassName = getBodyRowClassName(row);

    return (
      <RowComponent
        key={rowKey}
        cellClassName={cellClassName}
        className={bodyRowClassName}
        onRowClick={onRowClick}
        renderSubRow={renderSubRow}
        row={row}
        rowProps={rowProps}
      />
    );
  });
};
